import React from 'react';
import { citationText } from '../../config/staticText.config';
import {
  Page,
  Text,
  View,
  Image,
  Document,
  StyleSheet
} from '@react-pdf/renderer';
import wwfLogo from '../../Images/logo-WWF.jpg';
import WWF_Legend from '../../Images/WWF_Legend.jpg';
import SoilQualityXAxis from '../../Images/SoilQuality/soil-quality-values.jpg';
import SoilQualityLabels from '../../Images/SoilQuality/intact-plowprint.jpg';
import SoilQualityTitle from '../../Images/SoilQuality/title.jpg';

const titlePaddingLeft = '100';
const styles = StyleSheet.create({
  citation: {
    padding: '0 10%',
    fontSize: '9',
    color: '#888',
    subline: {
      paddingLeft: '13%',
      fontSize: '9',
      color: '#888',
    }
  },
  imageStyles: {
    paddingTop: '5',
    width: '50%',
    paddingLeft: '12',
    paddingRight: '5'
  },
  logo: {
    width: '80px',
    height: '80px',
    position: 'absolute',
    left: 10,
    top: 10,
    padding: 10,
    backgroundColor: 'white'
  },
  legend: {
    width: '236px',
    height: '24px',
    marginLeft: '25%',
    marginTop: '3'
  },
  mapSnapshot: {
    paddingLeft: '25',
    width: '55%',
    height: '100'
  },
  page: {
    flexDirection: 'column'
  },
  soilQuality: {
    width: '70%',
    height: '100px',
    paddingLeft: '5%',
    margin: 'auto',
    xAxis: {
      width: '425px',
      height: '9px',
      paddingLeft: '7%',
      margin: 'auto',
      marginBottom: '0',
      opacity: 0.9
    },
    title: {
      height: '13px',
      width: '195px',
      margin: 'auto'
    },
    labels: {
      position: 'absolute',
      top: '25px',
      left: '65px',
      width: '52px',
      height: '75px'
    }
  },
  subTitle: {
    color: '#888',
    fontSize: '14',
    paddingLeft: titlePaddingLeft,
    paddingTop: '5'
  },
  summaryText: {
    display: 'flex',
    flexDirection: 'column',
    width: '40%',
    paddingLeft: '1'
  },
  title: {
    backgroundColor: 'black',
    color: 'white',
    fontSize: 20,
    height: 60,
    width: '100%',
    paddingTop: 30,
    paddingLeft: titlePaddingLeft
  },
  view: {
    disply: 'flex',
    flexDirection: 'row',
    maxHeight: '190px',
    justifyContent: 'space-between'
  }
});

const ReportPDF = ({
  charts,
  snapshot,
  totalArea,
  subtitleText,
  yearsSelected
}) => {
  return (
    <Document>
      <Page id="test" size="A4" style={styles.page}>
        <Text style={styles.title}>Plowprint Report</Text>
        <Image src={wwfLogo} style={styles.logo} />
        <Text style={styles.subTitle}>
          {subtitleText}: {yearsSelected.start} - {yearsSelected.end}
        </Text>
        {totalArea > -1 &&
        <View
          style={{
            marginTop: '15',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between'
          }}
        >

          {snapshot && <Image style={styles.mapSnapshot} src={snapshot} />}
          <View style={styles.summaryText}>
            <Text style={{ fontSize: '18' }}>Area Summary:</Text>
            {totalArea > 0 && (
              <Text style={{ color: '#888', fontSize: '10' }}>
                Total Area {totalArea.toLocaleString()} ac ({yearsSelected.end})
              </Text>
            )}
            {charts.totalPlowprintArea > -1 && (
              <Text style={{ color: '#888', fontSize: '10' }}>
                Plowprint Extent {charts.totalPlowprintArea.toLocaleString()} ac
                ({yearsSelected.end})
              </Text>
            )}
            {charts.totalExpansionArea > -1 && (
              <Text style={{ color: '#888', fontSize: '10' }}>
                Plowprint Expansion {charts.totalExpansionArea.toLocaleString()}{' '}
                ac ({yearsSelected.start} - {yearsSelected.end})
              </Text>
            )}
            {charts.totalIntactArea > -1 && (
              <Text style={{ color: '#888', fontSize: '10' }}>
                Intact Habitat {charts.totalIntactArea.toLocaleString()} ac (
                {yearsSelected.end})
              </Text>
            )}
          </View>
        </View>}

        {charts.plowprintCompositionOwnership &&
        <View style={styles.view}>
          {charts.plowprintCompositionOwnership && (
            <Image
              style={styles.imageStyles}
              src={charts.plowprintCompositionOwnership.uri}
            />
          )}
          {charts.intactCompositionOwnership && (
            <Image
              style={styles.imageStyles}
              src={charts.intactCompositionOwnership.uri}
            />
          )}
        </View>}

        {charts.plowprintExpansion &&
        <View style={styles.view}>
          {charts.plowprintExpansion && (
            <Image
              style={styles.imageStyles}
              src={charts.plowprintExpansion.uri}
            />
          )}
          {charts.openWater && (
            <Image style={styles.imageStyles} src={charts.openWater.uri} />
          )}
        </View>}

        {charts.soilQuality.uri &&
        <View>
          <Image src={SoilQualityTitle} style={styles.soilQuality.title} />
          <Image src={SoilQualityLabels} style={styles.soilQuality.labels} />
          {charts.soilQuality && (
            <Image style={styles.soilQuality} src={charts.soilQuality.uri} />
          )}
          <Image src={SoilQualityXAxis} style={styles.soilQuality.xAxis} />
          <Image src={WWF_Legend} style={styles.legend} />
        </View>}

        <View>
          <Text style={styles.citation}>{citationText.title}</Text>
          <Text style={styles.citation}>{citationText.line1}</Text>
          <Text style={styles.citation.subline}>{citationText.subline1}</Text>
          <Text style={styles.citation}>{citationText.line2}</Text>
          <Text style={styles.citation.subline}>{citationText.subline2}</Text>
        </View>
      </Page>
    </Document>
  );
};

export default ReportPDF;
